import './assets/scss/main.scss';

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import App from './App';
import router from './router';
import store from './store';

import './filters';

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
  },

  mounted() {
    toastr.options.closeButton = true;
  },
});

Vue.use(AsyncComputed);

// message bus for events
window.bus = new Vue();
